/** All available balance report formats */
export enum BalanceReportFormatEnum {
  /** Sequential format */
  SEQUENTIAL = 'SEQUENTIAL',
  /** Classic format */
  CLASSIC = 'CLASSIC',
  /** User's format */
  USER = 'USER',
}
